import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { TotemMark } from '@/shared/brand/TotemLogo';

import { MY_APPOINTMENTS_QUERY } from './portal.gql';

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */

export function PortalAppointmentsPage(): JSX.Element {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery(MY_APPOINTMENTS_QUERY, { fetchPolicy: 'cache-and-network' });
  const appts: any[] = data?.myAppointments ?? [];

  return (
    <div className="space-y-3">
      <h2 className="font-display text-lg font-bold tracking-tight">{t('portal.nav_appointments')}</h2>
      {loading && appts.length === 0 ? (
        <p className="text-muted-foreground text-sm">{t('common.loading')}</p>
      ) : error && appts.length === 0 ? (
        <p className="text-destructive text-sm">{t('portal.load_error')}</p>
      ) : appts.length === 0 ? (
        <div className="flex flex-col items-center gap-2 py-10 text-center">
          <TotemMark className="text-muted-foreground/40 h-10 w-auto" aria-hidden />
          <p className="text-muted-foreground text-sm">{t('portal.no_appointments')}</p>
        </div>
      ) : (
        <ul className="space-y-2">
          {appts.map((a) => (
            <li key={a.id} className="bg-card rounded-lg border p-4">
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-medium">
                  {new Date(a.scheduled_start_at).toLocaleString([], {
                    dateStyle: 'medium',
                    timeStyle: 'short',
                  })}
                </span>
                <span className="text-muted-foreground text-xs">
                  {t(`portal.appt_status_${a.status}`, { defaultValue: a.status })}
                </span>
              </div>
              <p className="text-muted-foreground text-xs">
                {t(`portal.appt_kind_${a.appointment_kind}`, { defaultValue: a.appointment_kind })}
                {a.veterinarian_name ? ` · ${a.veterinarian_name}` : ''}
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
